import React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';

import Header from './../../component/common/Header';
import ModalWindow from '../../component/common/ModalWindow';
import AddComment from './../../component/leave/CommentWithStatus';
import OnlyComment from './../../component/leave/OnlyComment';
import Loader from './../../component/common/Loader';
import CONSTANT from './../../constant';
import Shimmer from '../../component/common/Shimmer';

import { getLeaveDetail, updateStatus, requestCancellation, manageCancellation } from '../../actions/LeaveAction';
import { getDateParts, getCookie, getStorage } from '../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.match.params.code,
            ud: getCookie(CONSTANT.cookie.userDetail),
            permissions: getStorage(CONSTANT.cookie.permissions),
            detail: undefined,
            // comments: undefined,
            showAddComment: false,
            showRequestCancellation: false,
            showManageCancellation: false,
            showCancelLeave: false,
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.leaveDetail;

        const { code } = this.state;
        getLeaveDetail(code).then((res: any) => {
            this.setState({ detail: res.result });
        });
    }

    render() {
        const { code, detail } = this.state;
        const { showAddComment, showLoader, ud, showManageCancellation, showRequestCancellation, showCancelLeave } = this.state;

        const showRequestCancellationButton = detail && detail.createdBy === ud.code;

        const showAddCommentButton = detail && detail.assignedTo === ud.code && detail.approved === null && detail.cancellationRequestedOn === null;
        const showManageCancellationButton = detail && detail.assignedTo === ud.code && detail.cancellationRequestedOn !== null && detail.cancellationStatus === null;
        const showAdminCancellationButton = detail && detail.assignedTo === ud.code && detail.cancellationRequestedOn === null && detail.cancellationStatus === null && detail.approved === true;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row my-3">
                            <div className="col-md-8">
                                <h1 className="page-title">Leave detail</h1>
                            </div>
                            <div className="col-md-4">
                                <Link to={CONSTANT.component.userLeaveList.url} className="btn btn-sm btn-link float-right">Go Back</Link>
                                <button onClick={this.onPrint} className="btn btn-sm btn-link float-right"><i className="fa fa-print" /> Print</button>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-md-12">
                                {
                                    detail === undefined && <Shimmer />
                                }
                                {
                                    detail !== undefined && this.renderDetail()
                                }
                                {
                                    detail !== undefined && (detail.leaveManagedOn !== null) && this.renderApproval()
                                }
                                {
                                    detail !== undefined && detail.cancellationRequestedOn !== null && this.renderCancellationRequest()
                                }
                                {
                                    detail !== undefined && detail.cancellationApprovedOn !== null && this.renderCancellationResponse()
                                }
                            </div>

                        </div>

                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
                {
                    showAddComment && <ModalWindow
                        title="Manage Leave"
                        backdrop="static"
                        toggleModal={this.toggleAddComment}
                    >
                        <AddComment
                            code={code}
                            onSubmit={this.onAddComment}
                            toggleModal={this.toggleAddComment}
                        />
                    </ModalWindow>
                }
                {
                    showRequestCancellation && <ModalWindow
                        title="Request Cancellation"
                        backdrop="static"
                        toggleModal={this.toggleReqeustCancellation}
                    >
                        <OnlyComment
                            code={code}
                            onSubmit={this.onRequestCancellation}
                            toggleModal={this.toggleReqeustCancellation}
                        />
                    </ModalWindow>
                }
                {
                    showManageCancellation && <ModalWindow
                        title="Manage Cancellation"
                        backdrop="static"
                        toggleModal={this.toggleManageCancellation}
                    >
                        <AddComment
                            code={code}
                            onSubmit={this.onManageCancellation}
                            toggleModal={this.toggleManageCancellation}
                        />
                    </ModalWindow>
                }
                {
                    showCancelLeave && <ModalWindow
                        title="Cancel Leave"
                        backdrop="static"
                        toggleModal={this.toggleCancelLeave}
                    >
                        <OnlyComment
                            code={code}
                            onSubmit={this.onCancelLeave}
                            toggleModal={this.toggleCancelLeave}
                        />
                    </ModalWindow>
                }
                {
                    showRequestCancellationButton && <button disabled={detail.cancellationRequestedOn !== null} className="comment-button btn btn-danger btn-sm" onClick={this.toggleReqeustCancellation}>
                        Request Cancellation
                    </button>
                }
                {
                    !showManageCancellationButton && showAddCommentButton && <div className="comment-button bg-primary text-white btn btn-sm" onClick={this.toggleAddComment}>
                        Manage Leave
                    </div>
                }
                {
                    showManageCancellationButton && <div className="comment-button btn btn-sm btn-danger" onClick={this.toggleManageCancellation}>
                        Manage Cancellation
                </div>
                }
                {
                    !showManageCancellationButton && !showAddCommentButton && showAdminCancellationButton && <div className="comment-button btn btn-sm btn-danger" onClick={this.toggleCancelLeave}>
                        Cancel Leave
                    </div>
                }
            </div>
        )
    }

    renderDetail = () => {
        const { detail } = this.state;
        const createdOn = getDateParts(detail.createdOn);
        const startDate = getDateParts(detail.startDate);
        const endDate = getDateParts(detail.endDate);
        const leaveDuration = CONSTANT.static.leaveDuration.filter((i: any) => i.code === detail.duration);

        return (
            <div className="card main-file mb-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            Address: {detail.addressTypeName} {detail.remoteAddress ? ` (${detail.remoteAddress})` : ''}<br />
                            Leave type: {detail.leaveTypeId == CONSTANT.static.leaveType.el ? 'Earned Leave' : detail.leaveTypeName}<br />
                            Duration: {(detail.leaveTypeId === CONSTANT.static.leaveType.cml || detail.leaveTypeId === CONSTANT.static.leaveType.hpl) && parseFloat(detail.noOfDays) === 1 ? `${leaveDuration[0].name}` : `${detail.noOfDays} Day(s)`} ({`${startDate.date} ${startDate.monthName} ${startDate.year} - ${endDate.date} ${endDate.monthName} ${endDate.year}`})<br />
                        </div>
                        <div className="col-md-12 text-justify">
                            <div dangerouslySetInnerHTML={{ __html: detail.reason.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                        </div>
                        <div className="col-md-12 mt-3 text-right">
                            <span className="fs-12">
                                {detail.createdByName}<br />
                                {detail.createdByDesignation}<br />
                                {`${createdOn.date} ${createdOn.monthName} ${createdOn.year} ${createdOn.hour}:${createdOn.minute}:${createdOn.seconds} ${createdOn.amOrpm}`}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderApproval = () => {
        const { detail } = this.state;
        const adt = getDateParts(detail.leaveManagedOn);
        return (
            detail.approved !== null && <div className="card mb-3 comment-file">
                {
                    detail.approved && <div className="card-header">
                        Approved
                    </div>
                }
                {
                    !detail.approved && <div className="card-header">
                        Rejected
                    </div>
                }
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 text-justify">
                            <div dangerouslySetInnerHTML={{ __html: detail.leaveManagedByComment.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                        </div>

                        <div className="col-md-12 mt-3 text-right">
                            <span className="fs-12">
                                {detail.leaveManagedByName}<br />
                                {detail.leaveManagedByDesignation}<br />
                                {`${adt.date} ${adt.monthName} ${adt.year} ${adt.hour}:${adt.minute}:${adt.seconds} ${adt.amOrpm}`}</span>
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    renderCancellationRequest = () => {
        const { detail } = this.state;
        const cdt = getDateParts(detail.cancellationRequestedOn);

        const renderDiv = () => {
            return (
                <div className="card mb-3 border border-danger comment-file">
                    <div className="card-header">
                        Requested Cancellation
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 text-justify">
                                <div dangerouslySetInnerHTML={{ __html: detail.cancellationRequestedReason.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                            </div>

                            <div className="col-md-12 mt-3 text-right">
                                <span className="fs-12">
                                    {detail.cancellationRequestedByName}<br />
                                    {detail.cancellationRequestedByDesignation}<br />
                                    {`${cdt.date} ${cdt.monthName} ${cdt.year} ${cdt.hour}:${cdt.minute}:${cdt.seconds} ${cdt.amOrpm}`}</span>
                            </div>

                        </div>
                    </div>
                </div>
            )
        }

        if (detail.cancellationRequestedOn !== null) {
            return renderDiv();
        } else {
            return null;
        }
    }

    renderCancellationResponse = () => {
        const { detail } = this.state;
        const cdt = getDateParts(detail.cancellationManagedOn);
        const renderDiv = () => {
            return (
                <div className="card mb-3 comment-file">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 text-justify">
                                <div dangerouslySetInnerHTML={{ __html: detail.cancellationManagedByComment.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                            </div>

                            <div className="col-md-12 mt-3 text-right">
                                <span className="fs-12">
                                    {detail.cancellationManagedByName}<br />
                                    {detail.cancellationManagedByDesignation}<br />
                                    {`${cdt.date} ${cdt.monthName} ${cdt.year} ${cdt.hour}:${cdt.minute}:${cdt.seconds} ${cdt.amOrpm}`}</span>
                            </div>

                        </div>
                    </div>
                </div>
            )
        }

        if (detail.cancellationManagedOn !== null) {
            return renderDiv();
        } else {
            return null;
        }
    }

    onAddComment = (model: any) => {
        this.setState({ showLoader: true });
        updateStatus(model).then(async (res: any) => {
            this.setState({ showLoader: false });
            if (res) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    this.props.history.push(CONSTANT.component.userLeaveList.url);
                } else {
                    alert(res.error);
                }
            }
        });
    }

    onRequestCancellation = (model: any) => {
        const isSure = window.confirm('Are you sure, you want to cancel your leave request?');
        if (isSure) {
            this.setState({ showLoader: true });
            requestCancellation(model).then((res: any) => {
                this.setState({ showLoader: false });
                alert('Requets for cancellation has been raised successfully.');
                this.props.history.push(CONSTANT.component.userLeaveList.url);
            })
        }
    }

    onManageCancellation = (model: any) => {
        const isSure = window.confirm('Are you sure, you want to update the leave status?');
        if (isSure) {
            this.setState({ showLoader: true });
            manageCancellation(model).then((res: any) => {
                this.setState({ showLoader: false });
                alert('Leave status has been updated successfully.');
                this.props.history.push(CONSTANT.component.userLeaveList.url);
            })
        }
    }

    onCancelLeave = (model: any) => {
        const isSure = window.confirm('Are you sure, you want to cancel the leave?');
        if (isSure) {
            model.status = true;
            model.leaveCode = model.code;
            this.setState({ showLoader: true });
            manageCancellation(model).then((res: any) => {
                this.setState({ showLoader: false });
                alert('Leave has been cancelled successfully.');
                this.props.history.push(CONSTANT.component.userLeaveList.url);
            })
        }
    }

    onPrint = (e: any) => {
        const mainSection = $('.main-file');
        const commentSection = $('.comment-file');
        let html = mainSection.html();
        for (let i = 0; i < commentSection.length; i++) {
            html += commentSection[i].innerHTML;
        }

        const style = `
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
        <style type="text/css">
        body{
            font-size:16px;
        }
        .no-print{visibility: hidden; display:none;}
        .card-body{
            border-bottom: 2px dotted gray;
        }
        
        @page{
            size:A4,
            margin-top: 2cm;
            margin-bottom: 2cm;
            margin-left:6cm;
            margin-right:1.5cm;
        }
        @media print {
            body
            {
                font-size:15.5pt;
            }
            
            .print-btn{
                visibility:hidden;
            }
        }
        </style>
        `;
        const innerHTML = `${style}<button class="print-btn float-right" onclick="window.print()">Print Now</button></div><div class="fluid-container">${html}<br/><button class="print-btn float-right" onclick="window.print()">Print Now</button></div>`;
        let myWindow: any = window.open('', '', 'width=800,height=600');
        myWindow.document.write(innerHTML);
        myWindow.focus();
    }

    toggleAddComment = () => {
        this.setState({ showAddComment: !this.state.showAddComment });
    }

    toggleManageCancellation = () => {
        this.setState({ showManageCancellation: !this.state.showManageCancellation });
    }

    toggleReqeustCancellation = () => {
        this.setState({ showRequestCancellation: !this.state.showRequestCancellation });
    }

    toggleCancelLeave = () => {
        this.setState({ showCancelLeave: !this.state.showCancelLeave });
    }
}

export default ComponentName;